module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/BEER@1x.png?1.0.17";